import Layout from "@/components/layout/Layout";
import HeroSection from "@/components/home/HeroSection";
import FeaturesSection from "@/components/home/FeaturesSection";
import PackagesPreview from "@/components/home/PackagesPreview";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import FAQSection from "@/components/home/FAQSection";
import PartnersSection from "@/components/home/PartnersSection";
import TrustBadgesSection from "@/components/home/TrustBadgesSection";
import SEOHead from "@/components/seo/SEOHead";
import SchemaMarkup from "@/components/seo/SchemaMarkup";

const homeFaqs = [
  {
    question: "What is BDIX hosting and why is it important?",
    answer: "BDIX (Bangladesh Internet Exchange) hosting provides ultra-fast connectivity within Bangladesh by routing traffic through local exchange points. This results in significantly lower latency and faster page load times for visitors within Bangladesh, making it ideal for local businesses and websites targeting Bangladeshi audiences.",
  },
  {
    question: "Do you offer free website migration?",
    answer: "Yes! We offer completely free website migration for all our hosting plans. Our expert team will migrate your website, databases, emails, and all files from your current host to our servers with zero downtime.",
  },
  {
    question: "What control panel do you use?",
    answer: "We use cPanel, the industry's most popular and user-friendly control panel. It provides an intuitive interface for managing your website, emails, databases, files, and more. We also offer one-click installers for WordPress, Joomla, and 400+ other applications.",
  },
  {
    question: "What is your uptime guarantee?",
    answer: "We guarantee 99.99% uptime for all our hosting services, backed by our Service Level Agreement (SLA). Our state-of-the-art datacenter infrastructure, redundant power systems, and 24/7 monitoring ensure your website stays online.",
  },
  {
    question: "Do you provide daily backups?",
    answer: "Yes, we perform automated daily backups of all hosting accounts. Backups are stored on separate servers for added security. You can also create manual backups anytime through cPanel or request restoration from our support team.",
  },
  {
    question: "How fast is your customer support?",
    answer: "Our customer support team is available 24/7 via live chat, phone, and ticket system. Average response time for live chat is under 2 minutes, and most tickets are resolved within 1 hour. Our support team consists of certified hosting experts.",
  },
];

const Index = () => {
  return (
    <Layout>
       <SEOHead
         title="Best BDIX Hosting Provider in Bangladesh | #1 Fastest &amp; Most Reliable"
         description="Web Host Buy BD - Bangladesh's #1 BDIX hosting provider. Best hosting in Bangladesh with NVMe SSD web hosting, VPS, dedicated servers from ৳599/year. 99.99% uptime guarantee &amp; 24/7 expert support. Best BDIX hosting in Bangladesh."
         canonical="/"
         keywords="best hosting in Bangladesh, best BDIX hosting in Bangladesh, best hosting provider in Bangladesh, bdix hosting, bdix hosting in bangladesh, Web Host Buy BD, Host BUY BD, Web Host BD, web host bd, web hosting bd, NVMe SSD hosting, what is bdix hosting, best bdix hosting, hosting bd, bd web hosting, cheap web hosting in bangladesh, bdix"
         priceLabel="Starting from"
         priceValue="৳599/year"
       />
      <SchemaMarkup 
        type="home" 
        faqs={homeFaqs}
        breadcrumbs={[{ name: "Home", url: "/" }]}
        pageName="Web Host Buy BD - Best BDIX Hosting Provider in Bangladesh"
        pageDescription="Bangladesh's #1 BDIX hosting provider offering fastest web hosting, NVMe SSD VPS, dedicated servers, and domain registration with 99.99% uptime."
      />
      <HeroSection />
      <PackagesPreview />
      <FeaturesSection />
      <TrustBadgesSection />
      <TestimonialsSection />
      <FAQSection />
      <PartnersSection />
    </Layout>
  );
};

export default Index;
